/* Redirection post-checkout : faite une seule fois, avec la langue, dans layout/theme.liquid. */

/* ---- Navbar scroll ---- */
const navbar = document.getElementById('navbar');
if (navbar) window.addEventListener('scroll', () => {  // pas d'en-tête sur /products et /cart
  navbar.classList.toggle('scrolled', window.scrollY > 20);
}, { passive: true });

/* ---- FAQ accordion ---- */
function toggleFaq(btn) {
  const item = btn.closest('.faq-item');
  const isActive = item.classList.contains('active');
  document.querySelectorAll('.faq-item').forEach(el => {
    el.classList.remove('active');
    const q = el.querySelector('.faq-item__question');
    if (q) q.setAttribute('aria-expanded', 'false');
  });
  if (!isActive) {
    item.classList.add('active');
    btn.setAttribute('aria-expanded', 'true');
  }
}

/* ---- Particles ---- */
(function() {
  const container = document.getElementById('particles');
  if (!container) return;
  const isMobile = window.innerWidth < 768;
  if (isMobile) return;
  const colors = ['rgba(155,107,173,', 'rgba(201,166,213,', 'rgba(133,86,147,'];
  for (let i = 0; i < 28; i++) {
    const p = document.createElement('div');
    p.className = 'particle';
    const size = Math.random() * 4 + 1;
    const color = colors[Math.floor(Math.random() * colors.length)];
    const opacity = Math.random() * 0.4 + 0.1;
    p.style.cssText = `
      width:${size}px; height:${size}px;
      background:${color}${opacity});
      left:${Math.random() * 100}%;
      top:${Math.random() * 100}%;
      animation-duration:${Math.random() * 20 + 10}s;
      animation-delay:${Math.random() * 15}s;
    `;
    container.appendChild(p);
  }
})();

/* ---- App mockup live feed (style réel VINTI) ---- */
(function() {
  var isLang = (document.documentElement.lang || '').startsWith('fr');
  var mockItems = [
    {name:'iPhone 13 Pro 128Go',brand:'Apple',size:'128Go',cond:isLang?'Très bon':'Very good',price:'310€',bg:'135deg,#1f2937,#4b5563',badge:'bought'},
    {name:'Samsung Galaxy S22',brand:'Samsung',size:'128Go',cond:isLang?'Bon état':'Good cond.',price:'185€',bg:'135deg,#0c4a6e,#0ea5e9',badge:'alert'},
    {name:'Nike Air Force 1',brand:'Nike',size:'42',cond:isLang?'Comme neuf':'Like new',price:'45€',bg:'135deg,#5a3a6d,#9b67c0',badge:'bought'},
    {name:isLang?'Lot 10 sweats vintage':'Vintage hoodie bundle x10',brand:isLang?'Lot friperie':'Bulk lot',size:'M-XL',cond:isLang?'Bon état':'Good cond.',price:'95€',bg:'135deg,#7c3808,#d97706',badge:'new'},
    {name:'iPhone 12 64Go',brand:'Apple',size:'64Go',cond:isLang?'Correct':'Fair',price:'225€',bg:'135deg,#374151,#6b7280',badge:'alert'},
    {name:'Jordan 1 Retro High',brand:'Jordan',size:'41',cond:isLang?'Bon état':'Good cond.',price:'89€',bg:'135deg,#3a1a60,#7b4cf6',badge:'new'},
    {name:"Levi's 501",brand:"Levi's",size:'W32',cond:isLang?'Bon état':'Good cond.',price:'28€',bg:'135deg,#5c2aed,#c084fc',badge:'new'},
    {name:isLang?'Lot 15 jeans marques':'Branded jeans lot x15',brand:isLang?'Lot friperie':'Bulk lot',size:'Mix',cond:isLang?'Très bon':'Very good',price:'120€',bg:'135deg,#164e63,#06b6d4',badge:'bought'},
    {name:'Carhartt WIP',brand:'Carhartt',size:'L',cond:isLang?'Très bon':'Very good',price:'65€',bg:'135deg,#7c3808,#d97706',badge:'alert'},
    {name:'Samsung Galaxy S21 FE',brand:'Samsung',size:'128Go',cond:isLang?'Comme neuf':'Like new',price:'155€',bg:'135deg,#1e3a5f,#4b8cf6',badge:'new'},
    {name:'New Balance 550',brand:'NB',size:'43',cond:isLang?'Neuf':'Brand new',price:'72€',bg:'135deg,#064e3b,#10b981',badge:'bought'},
    {name:isLang?'Lot vestes North Face':'North Face jacket lot',brand:'TNF',size:'Mix',cond:isLang?'Bon état':'Good cond.',price:'140€',bg:'135deg,#374151,#9ca3af',badge:'new'},
  ];
  var idx = 0;
  function addMockItem() {
    var feed = document.getElementById('mock-feed-en');
    if (!feed) return;
    var d = mockItems[idx % mockItems.length]; idx++;
    while (feed.children.length >= 4) feed.removeChild(feed.lastChild);
    var btnCls = d.badge === 'bought' ? 'app-mock__buy-btn app-mock__buy-btn--bought'
      : d.badge === 'alert' ? 'app-mock__buy-btn app-mock__buy-btn--alert'
      : 'app-mock__buy-btn';
    var btnTxt = d.badge === 'bought'
      ? (isLang ? '✓ Acheté' : '✓ Bought')
      : d.badge === 'alert'
      ? (isLang ? '⚡ Alerte' : '⚡ Alert')
      : (isLang ? 'Acheter' : 'Buy');
    var el = document.createElement('div');
    el.className = 'app-mock__item';
    el.style.opacity = '0';
    el.style.transform = 'translateY(-6px)';
    el.innerHTML =
      '<div class="app-mock__item-img" style="background:linear-gradient('+d.bg+')"></div>'
      + '<div class="app-mock__item-info">'
      +   '<div class="app-mock__item-name">'+d.name+'</div>'
      +   '<div class="app-mock__item-chips">'
      +     '<span class="app-mock__item-chip">'+d.brand+'</span>'
      +     '<span class="app-mock__item-chip">'+d.size+'</span>'
      +     '<span class="app-mock__item-cond">'+d.cond+'</span>'
      +   '</div>'
      + '</div>'
      + '<div class="app-mock__item-right">'
      +   '<div class="app-mock__item-price">'+d.price+'</div>'
      +   '<button class="'+btnCls+'">'+btnTxt+'</button>'
      + '</div>';
    feed.insertBefore(el, feed.firstChild);
    requestAnimationFrame(function() {
      el.style.transition = 'opacity .3s, transform .3s';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    });
  }
  var isMobile = window.innerWidth < 768;
  setTimeout(function(){addMockItem();}, 200);
  if (!isMobile) {
    setTimeout(function(){addMockItem();}, 600);
    setTimeout(function(){addMockItem();}, 1000);
    setTimeout(function(){addMockItem();}, 1400);
  }
  setInterval(addMockItem, isMobile ? 4500 : 2500);
})();


/* ---- Pub : lecteur avec barre de navigation ---- */
(function() {
  var player = document.querySelector('[data-film]');
  if (!player) return;
  var section = player.closest('.film'), video = player.querySelector('video');
  var seek = player.querySelector('[data-film-seek]'), cur = player.querySelector('[data-film-current]');
  var dur = player.querySelector('[data-film-duration]'), mute = player.querySelector('[data-film-mute]');
  var seeking = false, userPaused = false;
  function fmt(t) { t = Math.max(0, Math.floor(t || 0)); return Math.floor(t / 60) + ':' + String(t % 60).padStart(2, '0'); }
  function paint() {
    var d = video.duration || 0, p = d ? video.currentTime / d : 0;
    if (!seeking) seek.value = Math.round(p * 1000);
    seek.style.setProperty('--p', (seek.value / 10) + '%');
    cur.textContent = fmt(video.currentTime);
  }
  function play() { var r = video.play(); if (r && r.catch) r.catch(function() {}); }
  function toggle() { if (video.paused) { userPaused = false; play(); } else { userPaused = true; video.pause(); } }
  video.addEventListener('loadedmetadata', function() { dur.textContent = fmt(video.duration); paint(); });
  video.addEventListener('timeupdate', paint);
  video.addEventListener('play', function() { section.classList.add('is-playing'); });
  video.addEventListener('pause', function() { section.classList.remove('is-playing'); });
  video.addEventListener('click', toggle);
  player.querySelectorAll('[data-film-toggle]').forEach(function(b) { b.addEventListener('click', toggle); });
  seek.addEventListener('input', function() {
    seeking = true;
    if (video.duration) video.currentTime = seek.value / 1000 * video.duration;
    paint();
  });
  seek.addEventListener('change', function() { seeking = false; });
  mute.addEventListener('click', function() {
    video.muted = !video.muted;
    section.classList.toggle('has-sound', !video.muted);
    mute.setAttribute('aria-pressed', String(!video.muted));
    if (!video.muted && video.paused) { userPaused = false; play(); }
  });
  player.querySelector('[data-film-full]').addEventListener('click', function() {
    var el = player.requestFullscreen ? player : video;
    if (document.fullscreenElement) document.exitFullscreen();
    else if (el.requestFullscreen) el.requestFullscreen();
    else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
  });
  // Lecture muette automatique quand la pub est à l'écran (sauf si l'utilisateur l'a mise en pause).
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { if (!userPaused) play(); } else if (!video.paused) video.pause(); });
    }, { threshold: 0.35 }).observe(player);
  }
})();
